import Vue from 'vue'

class CommandRepository {

  // Une charge technique, sans membre : son motif est obligatoire (rôle Superviseur).
  remoteStartSession(evseId, technicalReason) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/remote-start-session',
        method: 'post',
        data: {
          evseId,
          technicalReason
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  // Les membres pour qui lancer une charge sur la borne : à domicile son membre, en entreprise les membres autorisés.
  // En GET, les paramètres passent par `data` (auth.fetch ignore `params`).
  chargeableMembers(chargingPointId, searchText) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/charging-point/${chargingPointId}/chargeable-members`,
        method: 'get',
        data: {searchText}
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  // La charge d'un membre, comme s'il la lançait depuis son application : ses droits, sa facturation.
  startChargeForMember(evseUid, memberId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/start-charge-for-member',
        method: 'post',
        data: {
          evseUid,
          memberId
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  remoteStopSession(evseId, sessionId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/remote-stop-session',
        method: 'post',
        data: {
          evseId,
          sessionId
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  unlockConnector(evseId, connectorId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/unlock-connector',
        method: 'post',
        data: {
          evseId,
          connectorId
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  cancelReservation(evseId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/cancel-reservation',
        method: 'post',
        data: {
          evseId,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  changeAvailability(chargingPointId, type, connectorId = null) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/change-availability',
        method: 'post',
        data: {
          chargingPointId,
          type,
          connectorId,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getConfiguration(chargingPointId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/get-configuration',
        method: 'post',
        data: {
          chargingPointId,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  changeConfigurations(chargingPointId, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/change-configuration',
        method: 'post',
        data: {
          chargingPointId,
          data,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  reset(chargingPointId, type = 'soft') {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/reset',
        method: 'post',
        data: {
          chargingPointId,
          type,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  clearCache(chargingPointId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/clear-cache',
        method: 'post',
        data: {
          chargingPointId,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  triggerMessage(chargingPointId, messageType, connectorId = null) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/commands/trigger-message',
        method: 'post',
        data: {
          chargingPointId,
          messageType,
          connectorId,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}


export default new CommandRepository()